<template>
  <div>
    <page-title value="サインアップ"></page-title>
    <v-container fluid class="pt-8">
      <v-form>
        <div>
          <p class="body-2 blue-grey--text">姓</p>
          <v-text-field
            v-model="postMeRequest.firstName"
            variant="outlined"
            density="compact"
          ></v-text-field>
        </div>

        <div>
          <p class="body-2 blue-grey--text">名前</p>
          <v-text-field
            v-model="postMeRequest.lastName"
            variant="outlined"
            density="compact"
          ></v-text-field>
        </div>

        <div>
          <p class="body-2 blue-grey--text">姓カナ</p>
          <v-text-field
            v-model="postMeRequest.firstNameKana"
            variant="outlined"
            density="compact"
          ></v-text-field>
        </div>

        <div>
          <p class="body-2 blue-grey--text">名前カナ</p>
          <v-text-field
            v-model="postMeRequest.lastNameKana"
            variant="outlined"
            density="compact"
          ></v-text-field>
        </div>

        <div class="d-flex justify-center my-5">
          <v-btn @click="postMe" color="primary" block variant="flat"> 送信 </v-btn>
        </div>
      </v-form>
    </v-container>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { PostMeRequest } from "@/model/Request";
import { meModule } from "@/store/dataModules/meModule";
import PageTitle from "@/components/atoms/PageTitle.vue";

interface DataType {
  postMeRequest: PostMeRequest;
}

export default defineComponent({
  name: "SignUp",

  components: {
    PageTitle,
  },

  data: () => ({
    postMeRequest: {
      firstName: "",
      lastName: "",
      firstNameKana: "",
      lastNameKana: "",
    },
  }),
  methods: {
    async postMe() {
      const response = await meModule.postMe(this.postMeRequest);
      if (response) {
        this.$router.push({ path: "/attendance/list" });
      }
    },
  },
});
</script>
